module.exports = __webpack_public_path__ + "img/enStub.aeb4fe91.png";